import _ from 'lodash'
import { Response } from 'superagent'

export class ListWithPagination<T> {
  static createFrom<T>(response: Response, mapper?: (item: any) => T): ListWithPagination<T> {
    const { data } = response.body

    if (!_.isArray(data)) {
      throw new Error('This response is not an array type.')
    }

    return new ListWithPagination({
      list: mapper ? data.map(mapper) : data,
      pagination: Pagination.createFrom(response),
    })
  }
  constructor(private params: {
    list: T[],
    pagination: Pagination
  }) {}

  get list(): T[] {
    return this.params.list
  }

  get pagination(): Pagination {
    return this.params.pagination
  }
}

/**
 * TODO: This pagination structure is specific to Engine response.
 * Refactor this class to more general structure, if needed.
 */
export class Pagination {
  static createFrom(response: Response): Pagination {
    return new Pagination(response.body)
  }

  constructor(private params: PaginationParams) {}

  get length(): number {
    return this.params.length
  }

  get total(): number {
    return this.params.total
  }

  get remainder(): number {
    return this.params.remainder
  }

  get hasNextPage(): boolean {
    return this.remainder > 0
  }

  get isLastPage(): boolean {
    return this.length > 0 && !this.hasNextPage
  }

  get exceedsLastPage(): boolean {
    return !this.hasNextPage && !this.isLastPage
  }

  with(params: Partial<PaginationParams>): Pagination {
    return new Pagination({
      ...this.params,
      ...params,
    })
  }
}
interface PaginationParams {
  length: number,
  total: number,
  remainder: number,
}
